module.exports = __webpack_public_path__ + "img/mobile-marketing-rafiki.f9a535f7.svg";